import { useState, useEffect, useMemo } from 'react';
import { CommonDialog, FormField2 as Field } from 'components';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import api from 'utils/api';
import {
  blobToFileDownload,
  toast,
} from 'utils/helpers';
import { userService } from 'views/Users/_services';

import {
    ArrowBack as ArrowBackIcon,
    NotificationsOutlined as NotificationsIcon,
    GetApp as DownloadIcon,
    ErrorOutline as ErrorIcon,
} from '@material-ui/icons';
import { Button } from '@material-ui/core';

const NotificationModal = ({ accountId, isOpen, onClose }) => {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');
    const [notifications, setNotifications] = useState([]);
    const [filteredNotifications, setFilteredNotifications] = useState([]);

    const fetchNotifications = async () => {
        try {
            const { data } = await api.get(`/accounts/${accountId}/notifications`);
            setNotifications(data);
            setFilteredNotifications(data);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchNotifications();
        }
    }, [isOpen]);

    useMemo(() => {
        if (!searchTerm) {
            setFilteredNotifications(notifications);
        } else {
            const filtered = notifications.filter(notification =>
            notification.content.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredNotifications(filtered);
        }
    }, [notifications, searchTerm]);

    if (!isOpen) return null;

    const renderStatusIndicator = (status) => {
        const className = `notification-status ${status}`;
        const textMap = {
        processing: t('Ruošiama'),
        ready: t('Atsisiųsti'),
        completed: t('Atidaryti'),
        failed: t('Klaida'),
        deleted: t('Pašalinta'),
        };

        return (
        <div className={className}>{textMap[status] || '-'}</div>
        )
    };

    const renderNotificationIcon = (notification) => {
        if (!!notification.file && notification.status === 'ready') {
          return <DownloadIcon style={{ marginTop: '3px' }} />;
        }
        switch (notification.status) {
          case 'error':
            return <ErrorIcon style={{ color: 'red' }} />;
          case 'ready':
            return <NotificationsIcon style={{ marginTop: '3px' }} />;
          default:
            return;
        }
    }

    const handleNotificationClick = async (record) => {
        // if notification has a file -> download
        if (record.file) {
            try {
                const { data } = await api.get(`/notifications/${record._id}/download`);
                const { fileName, contentType, content } = data;

                var bytes = new Uint8Array(content);
                const blob = new Blob([bytes], { type: contentType });

                blobToFileDownload(fileName, blob);
            } catch (err) {
                console.error(err);
            }
        }

        // if notification has a link -> navigate
        if (record.link && !record?.file) {
            window.location.href = record.link;
        }

        // Update notification as opened
        userService.setNotificationOpened(accountId, record._id);
    }

    const handleOpenAll = async () => {
        if (!window.confirm(t('Ar tikrai norite pašalinti visus pranešimus?'))) {
            return;
        }
        try {
            await api.post(`/notifications/open-all`);
            setSearchTerm('');
            toast(t('Pranešimai pašalinti'), 'success');
            onClose();
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <CommonDialog
            visible
            onClose={onClose}
            maxWidth="xs"
            style={{ position: "relative" }}
            showClose
            actions={[
                <>
                    <Button key="delete" onClick={handleOpenAll} size="small" color="secondary" variant="contained" className="btn btn-secondary">
                        {t('Pašalinti visus')}
                    </Button>
                    <Button key="close" onClick={onClose} size="small" color="primary" variant="contained" className="btn btn-primary">
                        {t('Uždaryti')}
                    </Button>
                </>
            ]}
        >
            <div className="notification-wrap" style={{ padding: '10px', maxHeight: '55vh' }}>
                <div>
                    <h2 style={{ marginBottom: 0 }}>{t('Pranešimai')}</h2>
                    <Field
                        type="text"
                        label={t("Paieška")}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.value)}
                    />
                </div>
                {filteredNotifications.length
                    ? <ul className="notification-list" style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                        {filteredNotifications.map((record) => (
                            <li className={`notification-item-${record.status}`} key={record._id} onClick={() => handleNotificationClick(record)}>
                                <div className="col-left" style={{ width: '80%' }}>
                                    <span className="notification-link">
                                    <div className="notification-ts">
                                        {moment(record.createdAt).format('YYYY-MM-DD HH:mm')}
                                    </div>
                
                                    {record.content}

                                    </span>
                                </div>
                                <div className="col-right" style={{ width: '20%' }}>
                                    {record.formNumber && <div className="form-number">{record.formNumber}</div>}
                                    {renderNotificationIcon(record)}
                                </div>
                
                                <div className="notification-status-wrap">
                                    {record.status != 'new' && renderStatusIndicator(record.status)}
                                </div>
                            </li>
                        ))}
                    </ul>
                    : <div style={{ textAlign: 'center', marginTop: '20px' }}>{t('Nėra pranešimų')}</div> 
                }
        </div>
    </CommonDialog>
  );
};

export default NotificationModal;
